module.exports = __webpack_public_path__ + "resource/img/train04.4e959a3f.png";